import { ArrowUpRight, ShieldCheck, Gauge, Users2 } from "lucide-react";
import PageHero from "../components/sections/PageHero";

const products = [
  {
    icon: ShieldCheck,
    name: "Trustatwork",
    tagline: "The Workplace Trust Index",
    desc: "A first-of-its-kind EQ + Trust certification — measure, benchmark and certify trust inside the organisation.",
  },
  {
    icon: Gauge,
    name: "Skills Lens",
    tagline: "Skill assessment, reimagined",
    desc: "Role-mapped, scenario-led assessments that surface real-world capability — not test-taking talent.",
  },
  {
    icon: Users2,
    name: "WorkPing",
    tagline: "Bulk hiring, made easy",
    desc: "A high-velocity hiring layer purpose-built for bulk hiring — sourcing to shortlist to offer, without losing signal.",
  },
];

const WHATSAPP_DEMO = (name) =>
  `https://wa.me/918122431120?text=${encodeURIComponent(
    `Hi Deployedd Labs — I'd like to initiate a discussion about "${name}".`
  )}`;
const WHATSAPP_GENERIC =
  "https://wa.me/918122431120?text=Hi%20Deployedd%20Labs%20%E2%80%94%20I%27d%20like%20to%20connect%20about%20Deployedd%20Digital.";

const SaaS = () => (
  <div data-testid="saas-page">
    <PageHero
      kicker="/ Deployedd Digital — SaaS"
      title="Software for the way"
      accent="we actually deploy talent."
      breadcrumb={["Deployedd Digital"]}
      lead="Three platforms — currently in active development. Built for institutions, talent partners and high-velocity hiring teams."
    />

    <section className="container-wide py-24 md:py-32">
      <div className="flex items-center justify-between gap-4 mb-10 flex-wrap">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A]">/ Upcoming · In Development</p>
        <a
          href={WHATSAPP_GENERIC}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="saas-connect-cta"
          className="inline-flex items-center gap-2 border border-ink px-5 py-2.5 text-[11px] uppercase tracking-[0.25em] hover:bg-ink hover:text-white transition-colors"
        >
          Connect on WhatsApp <ArrowUpRight className="w-3.5 h-3.5" />
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-ink">
        {products.map((p, i) => {
          const Icon = p.icon;
          return (
            <div key={p.name} data-testid={`product-${i}`} className="border-r border-b border-ink p-10 md:p-12 group hover:bg-[#F3F3F1] transition-colors relative flex flex-col">
              <div className="flex items-start justify-between mb-10">
                <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A]">/ Product 0{i + 1}</p>
                <span data-testid={`product-status-${i}`} className="inline-flex items-center gap-2 px-2.5 py-1 border border-ink text-[10px] uppercase tracking-[0.2em] text-ink">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#9F381A]" /> In Development
                </span>
              </div>
              <Icon className="w-7 h-7 text-ink-muted group-hover:text-[#9F381A] transition-colors mb-6" />
              <h3 className="font-heading text-3xl md:text-4xl tracking-tight mb-2">{p.name}</h3>
              <p className="font-editorial italic text-lg text-[#9F381A] mb-5">{p.tagline}</p>
              <p className="text-base text-ink-muted leading-relaxed mb-8 flex-1">{p.desc}</p>
              <a
                href={WHATSAPP_DEMO(p.name)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`product-cta-${i}`}
                className="inline-flex items-center justify-between gap-2 bg-ink text-white px-5 py-3 text-[11px] uppercase tracking-[0.25em] hover:bg-[#9F381A] transition-colors"
              >
                Initiate Discussion <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </div>
          );
        })}
      </div>
    </section>

    <section className="container-wide py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <h2 className="font-heading text-4xl md:text-5xl tracking-tighter leading-[0.95]">
          Early conversations only at this stage.<br />
          <em className="font-editorial italic text-[#9F381A]">Be the first to pilot.</em>
        </h2>
      </div>
      <div className="lg:col-span-4">
        <a
          href={WHATSAPP_GENERIC}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="saas-cta"
          className="inline-flex items-center justify-between w-full md:w-auto gap-3 bg-ink text-white px-6 py-4 text-[11px] uppercase tracking-[0.25em] hover:bg-[#9F381A] transition-colors"
        >
          Initiate Discussion · WhatsApp <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  </div>
);

export default SaaS;
